<template>
  <!-- Nuxt项目的写法 -->
  <!-- 使用Nuxt时，~/layout/ 文件夹中的vue组件会被自动注册 -->
  <!--   通过<NuxtLayout name="组件名"/>即可使用对应的组件 -->
  <!--   例如 ~/layout/AaBb.vue，默认情况下name为横线风格(kebab-case) -->
  <!--     <NuxtLayout name="aa-bb"/> -->
  <!--   如果<NuxtLayout/>不指定name，则默认为default，对应 ~/layout/default.vue -->
  <!-- 在Nuxt中，应该使用<NuxtPage/>来代替<RouterView/> -->
  <NuxtLayout name="basic-layout">
    <NuxtPage/>
  </NuxtLayout>

  <!-- 纯Vue项目的写法 -->
  <!-- <BasicLayout>
    <RouterView/>
  </BasicLayout> -->
</template>

<script setup>
import * as Vue from 'vue'
import BasicLayout from '@/layouts/BasicLayout.vue'

</script>

<style scoped>
</style>
